import React from "react";
import ConditionalLink from "components/ConditionalLink";
import Icon from "components/CommonIcon/Icon";

const NavButton = ({ label, prefixIcon, ...props }) => {
  const Content = () => {
    return (
      <>
        <div className="flex items-center font-mulish text-14-22 text-gray-text">
          <span className="inline-block mr-8">{prefixIcon}</span>
          {label}
        </div>
        <Icon name="right-arrow" fontSize="text-16" />
      </>
    );
  };

  return props.onClick ? (
    <a
      {...props}
      className="flex justify-between items-center border border-gray-med p-12 rounded-sm bg-white cursor-pointer">
      <Content />
    </a>
  ) : (
    <ConditionalLink
      {...props}
      link={props.href}
      className="flex justify-between items-center border border-gray-med p-12 rounded-sm bg-white cursor-pointer">
      <Content />
    </ConditionalLink>
  );
};

export default NavButton;
